import PropTypes from 'prop-types'

import SpaceLandingBody from './SpaceLandingBody'
import SpaceLandingDocumentation from './SpaceLandingDocumentation'
import SpaceLandingHeader from './SpaceLandingHeader'
import SpaceLandingIcon from './SpaceLandingIcon'
import SpaceLandingLink from './SpaceLandingLink'
import SpaceLandingLinks from './SpaceLandingLinks'
import SpaceLandingTitle from './SpaceLandingTitle'

import './index.scss'

const SpaceLanding = ({ children }: any) => <div className="space-page-landing">{children}</div>

SpaceLanding.displayName = 'SpaceLanding'

SpaceLanding.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)])
}

SpaceLanding.defaultProps = {
  children: null
}

SpaceLanding.Body = SpaceLandingBody
SpaceLanding.Icon = SpaceLandingIcon
SpaceLanding.Documentation = SpaceLandingDocumentation
SpaceLanding.Header = SpaceLandingHeader
SpaceLanding.Link = SpaceLandingLink
SpaceLanding.Links = SpaceLandingLinks
SpaceLanding.Title = SpaceLandingTitle

export default SpaceLanding
